import React, {useEffect, useRef} from "react";
import SingleStore from "./SingleStore";
import useStore from "../store";
import strings from "../lang/Localiz";
import ScrollComponent from "./ScrollComponents";

function HudStore() {
    const modal_showStore = useStore((state) => state.modal_showStore);
    const modalStore = useStore((state) => state.modalStore);
    const give_prize = useStore((state) => state.give_prize);

    const i = useStore((state) => state.i);

    const current = i <= 1 ? 0 : Math.ceil(i / 17);
    const scrollRef = useRef(null);


    function Close() {
        modal_showStore();
    }

    const circle = 7;

    let store = [];

    for (let c = 0; c < circle; c++) {
        store[c] = give_prize[c];
    }

    useEffect(() => {
        if (scrollRef.current && modalStore) {
            const storeElements = scrollRef.current.querySelectorAll('.single-store');
            if (storeElements && storeElements.length > 0) {
                const currentElement = current < 7 ? storeElements[current] : storeElements[current - 1];

                if (currentElement) {
                    currentElement.scrollIntoView({
                        behavior: 'smooth',
                        block: 'nearest',
                        inline: 'center'
                    });
                }
            }
        }
    }, [modalStore, current]);

    if (modalStore) {
        return (
            <div className={"hud-modal"}>
                <div className="close-wrapper" onClick={Close}></div>
                <div className={"hud-store modal-game"}>
                    <div className="hud-store-content-wrapper">
                        <div className={"hud-title"}>{strings.store.title}</div>
                        <div className="content-wrapper">
                            <ScrollComponent
                                ref={scrollRef}
                                direction="horizontal"
                                className={"content-store"}
                            >
                                {store.map((props, i) => (
                                    <SingleStore
                                        key={i}
                                        current={current}
                                        lvl={i}
                                        givePrize={props}
                                    />
                                ))}
                            </ScrollComponent>
                        </div>
                        <div onClick={Close} className={"btn-close-store approve-btn"}>
                            {strings.store.close}
                        </div>
                    </div>

                </div>
            </div>
        );
    } else {
        return null;
    }
}

export default HudStore;
